import { Money, PlainMessage } from "frontend-client";

export const getConvertedValue = (value?: PlainMessage<Money>) => {
  let convertedValue = 0;

  if (!value) return convertedValue;
  const decimalCount = value.decimalCount ?? 0;

  convertedValue = Number(value.amount) / Math.pow(10, decimalCount);

  if (isNaN(convertedValue)) {
    convertedValue = 0;
  }

  return Number(convertedValue.toFixed(decimalCount));
};

export const displayMonetaryValue = (
  value?: PlainMessage<Money>,
  locale?: string
): string => {
  if (!value) {
    return "";
  }

  // we need to figure this out
  if (!value.currencyCode) {
    value.currencyCode = "USD";
  }

  const amountFormatter = new Intl.NumberFormat(locale || "en-US", {
    style: "currency",
    currency: value.currencyCode,
    maximumFractionDigits: value.decimalCount ?? 0,
  });
  // handle decimal manipulation
  const convertedValue = getConvertedValue(value);

  return amountFormatter.format(convertedValue);
};
